import React, { useState } from 'react';
import './CierreTurno.css';

const CamposFormulario = ({ filtros, onChange, getInputConfig, tipo, isBusy }) => (
  <div className="filtro-campos">
    {tipo === "TRANSACCIONAL" ? (
      <>
        <div className="filtro-grupo">
          <label>Código Terminal:</label>
          <input
            type="text"
            name="codTerminal"
            value={filtros.codTerminal}
            onChange={onChange}
            disabled={isBusy}
            className="filtro-input"
            placeholder="Ingrese el código terminal"
          />
        </div>
        <div className="filtro-grupo">
          <label>Código Parqueadero:</label>
          <input
            type="text"
            name="codPark"
            value={filtros.codPark}
            onChange={onChange}
            disabled={isBusy}
            className="filtro-input"
            placeholder="Ingrese el código parqueadero"
          />
        </div>
        <div className="filtro-grupo">
          <label>Número de Factura:</label>
          <input
            type="text"
            name="numFactura"
            value={filtros.numFactura}
            onChange={onChange}
            disabled={isBusy}
            className="filtro-input"
            placeholder="Ingrese el número de factura"
          />
        </div>
      </>
    ) : (
      <>
        <div className="filtro-grupo">
          <label>Código Terminal:</label>
          <input
            type="text"
            name="codTerminal"
            value={filtros.codTerminal}
            onChange={onChange}
            disabled={isBusy || getInputConfig("codTerminal")}
            required={!getInputConfig("codTerminal")}
            className="filtro-input"
            placeholder="Ingrese el código terminal"
          />
        </div>

        <div className="filtro-grupo">
          <label>Centro de Costos:</label>
          <input
            type="text"
            name="codPark"
            value={filtros.codPark}
            onChange={onChange}
            disabled={isBusy || getInputConfig("codPark")}
            required={!getInputConfig("codPark")}
            className="filtro-input"
            placeholder="Ingrese el centro de costos"
          />
        </div>

        <div className="filtro-grupo fecha-grupo">
          <label>Fecha:</label>
          <input
            type="date"
            name="fechaInicial"
            value={filtros.fechaInicial}
            onChange={onChange}
            disabled={isBusy || getInputConfig("fechaInicial")}
            required={!getInputConfig("fechaInicial")}
            className="filtro-input fecha-input"
          />
        </div>
      </>
    )}
  </div>
);

const Formulario = ({ titulo, tipo, filtros, onChange, onSubmit, onClear, getInputConfig, isLoading = false }) => {
  const [error, setError] = useState(null);
  const [resultados, setResultados] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    onSubmit(e);
  };

  return (
    <div className="form-section">
      <h3 className="form-title">{titulo}</h3>
      <form onSubmit={handleSubmit} className="form-container">
        <div className="form-layout">
          <CamposFormulario 
              filtros={filtros} 
              onChange={onChange} 
              getInputConfig={getInputConfig}
              tipo={tipo}
              isBusy={isLoading}
          />
        </div>
        <div className="buttons-container">
          <button type="submit" className="btn-primary" disabled={isLoading}>
            {isLoading ? <i className="fas fa-spinner fa-spin"></i> : <i className="fas fa-search"></i>}
            {isLoading ? 'Buscando...' : 'Buscar'}
          </button>
          <button type="button" className="btn-secondary" onClick={onClear} disabled={isLoading}>
            <i className="fas fa-eraser"></i>Limpiar
          </button>
        </div>
        {isLoading && (
          <p className="form-loading-hint" role="status" aria-live="polite">
            Cargando cierre de turno y cierre de día…
          </p>
        )}
        {error && (
          <div className="error-message">
            <i className="fas fa-exclamation-circle"></i> {error}
          </div>
        )}
        {resultados && (
          <div className="resultados-container">
            {/* Aquí puedes mostrar los resultados de la búsqueda */}
            <pre>{JSON.stringify(resultados, null, 2)}</pre>
          </div>
        )}
      </form>
    </div>
  );
};

const CierreTurnoListForm = ({ filtros, onChange, onSubmit, onClear, getInputConfig, isBuscando = false }) => {
    return (
        <div className="forms-container">
            <Formulario
                titulo="Consulta Cierre turnos y Dia"
                tipo="CIERRE_TURNO"
                filtros={filtros}
                onChange={onChange}
                onSubmit={onSubmit}
                onClear={onClear}
                getInputConfig={getInputConfig}
                isLoading={isBuscando}
            />
        </div>
    );
};

export default CierreTurnoListForm;
